export const LayoutContract = {
  counters: {
    u_column: 17,
    u_row: 12,
    u_content_image: 3,
    u_content_text: 14,
    u_content_divider: 9,
    u_content_heading: 1,
  },
  body: {
    id: "x4P0M3f6ue",
    rows: [
      {
        id: "8gxvlIOota",
        cells: [27.78, 72.22],
        columns: [
          {
            id: "9-k0I9RMpZ",
            contents: [
              {
                id: "AX6nqvygdI",
                type: "image",
                values: {
                  containerPadding: "10px",
                  anchor: "",
                  src: {
                    url: sessionStorage.getItem("key_logo")
                      ? `https://qerp-public.s3.sa-east-1.amazonaws.com/${sessionStorage.getItem(
                          "key_logo"
                        )}`
                      : "https://assets.unlayer.com/stock-templates1684262438985-logo.png",
                    width: 130,
                    height: 95,
                  },
                  textAlign: "center",
                  altText: "",
                  action: {
                    name: "web",
                    values: { href: "", target: "_blank" },
                  },
                  hideDesktop: false,
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_image_3",
                    htmlClassNames: "u_content_image",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                },
              },
            ],
            values: {
              backgroundColor: "",
              padding: "0px",
              border: {},
              borderRadius: "0px",
              _meta: { htmlID: "u_column_11", htmlClassNames: "u_column" },
            },
          },
          {
            id: "xeovuQR6sN",
            contents: [
              {
                id: "sCjoRTnFMp",
                type: "heading",
                values: {
                  containerPadding: "10px",
                  anchor: "",
                  headingType: "h1",
                  fontSize: "22px",
                  textAlign: "center",
                  lineHeight: "140%",
                  linkStyle: {
                    inherit: true,
                    linkColor: "#0000ee",
                    linkHoverColor: "#0000ee",
                    linkUnderline: true,
                    linkHoverUnderline: true,
                  },
                  hideDesktop: false,
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_heading_1",
                    htmlClassNames: "u_content_heading",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                  text: "<strong>CONTRATO DE PRESTAÇÃO DE SERVIÇOS CONTÁBEIS</strong>",
                },
              },
            ],
            values: {
              backgroundColor: "",
              padding: "0px",
              border: {},
              borderRadius: "0px",
              _meta: { htmlID: "u_column_12", htmlClassNames: "u_column" },
            },
          },
        ],
        values: {
          displayCondition: null,
          columns: false,
          backgroundColor: "",
          columnsBackgroundColor: "",
          backgroundImage: {
            url: "",
            fullWidth: true,
            repeat: "no-repeat",
            size: "custom",
            position: "center",
          },
          padding: "0px",
          anchor: "",
          hideDesktop: false,
          _meta: { htmlID: "u_row_9", htmlClassNames: "u_row" },
          selectable: true,
          draggable: true,
          duplicatable: true,
          deletable: true,
          hideable: true,
        },
      },
      {
        id: "dRGuCRV_t7",
        cells: [50],
        columns: [
          {
            id: "p2L0YDZmlh",
            contents: [
              {
                id: "OByBJ9Pj2_",
                type: "divider",
                values: {
                  width: "100%",
                  border: {
                    borderTopWidth: "1px",
                    borderTopStyle: "solid",
                    borderTopColor: "#BBBBBB",
                  },
                  textAlign: "center",
                  containerPadding: "10px",
                  anchor: "",
                  hideDesktop: false,
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_divider_6",
                    htmlClassNames: "u_content_divider",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                },
              },
              {
                id: "6IZqQzb7Xj",
                type: "text",
                values: {
                  containerPadding: "10px",
                  anchor: "",
                  fontSize: "14px",
                  textAlign: "left",
                  lineHeight: "140%",
                  linkStyle: {
                    inherit: true,
                    linkColor: "#0000ee",
                    linkHoverColor: "#0000ee",
                    linkUnderline: true,
                    linkHoverUnderline: true,
                  },
                  hideDesktop: false,
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_text_4",
                    htmlClassNames: "u_content_text",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                  text: '<p style="line-height: 140%;"><strong>CONTRATADA</strong></p>\n<p style="line-height: 140%;"><strong>[empresa_razao]</strong></p>\n<p style="line-height: 140%;">CNPJ: [empresa_cnpj]               I.E.:[empresa_incs]</p>\n<p style="line-height: 140%;">[empresa_end] - [empresa_comp] -  [empresa_bairro] - [empresa_cep]</p>\n<p style="line-height: 140%;">[empresa_cidade] / [empresa_est]</p>\n<p style="line-height: 140%;">[empresa_tel]</p>\n<p style="line-height: 140%;">[empresa_mail] </p>',
                },
              },
              {
                id: "QfwU63bm1B",
                type: "divider",
                values: {
                  width: "100%",
                  border: {
                    borderTopWidth: "1px",
                    borderTopStyle: "solid",
                    borderTopColor: "#BBBBBB",
                  },
                  textAlign: "center",
                  containerPadding: "10px",
                  anchor: "",
                  hideDesktop: false,
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_divider_1",
                    htmlClassNames: "u_content_divider",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                },
              },
            ],
            values: {
              backgroundColor: "",
              padding: "0px",
              border: {
                borderTopWidth: "0px",
                borderTopStyle: "solid",
                borderTopColor: "#000000",
                borderLeftWidth: "0px",
                borderLeftStyle: "solid",
                borderLeftColor: "#000000",
                borderRightWidth: "0px",
                borderRightStyle: "solid",
                borderRightColor: "#000000",
                borderBottomWidth: "0px",
                borderBottomStyle: "solid",
                borderBottomColor: "#000000",
              },
              borderRadius: "0px",
              _meta: { htmlID: "u_column_5", htmlClassNames: "u_column" },
            },
          },
        ],
        values: {
          displayCondition: null,
          columns: false,
          backgroundColor: "",
          columnsBackgroundColor: "",
          backgroundImage: {
            url: "",
            fullWidth: true,
            repeat: "no-repeat",
            size: "custom",
            position: "center",
          },
          padding: "0px",
          anchor: "",
          hideDesktop: false,
          _meta: { htmlID: "u_row_4", htmlClassNames: "u_row" },
          selectable: true,
          draggable: true,
          duplicatable: true,
          deletable: true,
          hideable: true,
        },
      },
      {
        id: "HPlU0XhShn",
        cells: [1],
        columns: [
          {
            id: "Fk6pM81I3l",
            contents: [
              {
                id: "sTl-S7A4KM",
                type: "text",
                values: {
                  containerPadding: "10px",
                  anchor: "",
                  fontSize: "14px",
                  textAlign: "left",
                  lineHeight: "140%",
                  linkStyle: {
                    inherit: true,
                    linkColor: "#0000ee",
                    linkHoverColor: "#0000ee",
                    linkUnderline: true,
                    linkHoverUnderline: true,
                  },
                  hideDesktop: false,
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_text_12",
                    htmlClassNames: "u_content_text",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                  text: '<p style="line-height: 140%;"><strong>CONTRATANTE</strong></p>\n<p style="line-height: 140%;"><strong>[cliente_razao]</strong></p>\n<p style="line-height: 140%;">CNPJ: [cliente_cnpj]            I.E.:[cliente_incs]</p>\n<p style="line-height: 140%;">[cliente_end] - [cliente_comp] - [cliente_bairro] - [cliente_cep]</p>\n<p style="line-height: 140%;">[cliente_cidade] / [cliente_est]</p>\n<p style="line-height: 140%;">[cliente_tel]</p>\n<p style="line-height: 140%;">[cliente_mail]</p>',
                },
              },
              {
                id: "kD_wA_odTI",
                type: "divider",
                values: {
                  width: "100%",
                  border: {
                    borderTopWidth: "1px",
                    borderTopStyle: "solid",
                    borderTopColor: "#BBBBBB",
                  },
                  textAlign: "center",
                  containerPadding: "10px",
                  anchor: "",
                  hideDesktop: false,
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_divider_8",
                    htmlClassNames: "u_content_divider",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                },
              },
            ],
            values: {
              backgroundColor: "",
              padding: "0px",
              border: {},
              borderRadius: "0px",
              _meta: { htmlID: "u_column_15", htmlClassNames: "u_column" },
            },
          },
        ],
        values: {
          displayCondition: null,
          columns: false,
          backgroundColor: "",
          columnsBackgroundColor: "",
          backgroundImage: {
            url: "",
            fullWidth: true,
            repeat: "no-repeat",
            size: "custom",
            position: "center",
          },
          padding: "0px",
          anchor: "",
          hideDesktop: false,
          _meta: { htmlID: "u_row_11", htmlClassNames: "u_row" },
          selectable: true,
          draggable: true,
          duplicatable: true,
          deletable: true,
          hideable: true,
        },
      },
      {
        id: "ZBxX4pK3vt",
        cells: [45.25, 54.75],
        columns: [
          {
            id: "Wfa0XYUzGH",
            contents: [
              {
                id: "wSbXzMCNug",
                type: "text",
                values: {
                  containerPadding: "10px",
                  anchor: "",
                  fontSize: "14px",
                  textAlign: "left",
                  lineHeight: "140%",
                  linkStyle: {
                    inherit: true,
                    linkColor: "#0000ee",
                    linkHoverColor: "#0000ee",
                    linkUnderline: true,
                    linkHoverUnderline: true,
                  },
                  hideDesktop: false,
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_text_6",
                    htmlClassNames: "u_content_text",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                  text: '<p style="line-height: 140%;"><strong>CONTRATO - [contrato_num]</strong></p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;"><strong>Data: </strong>[contrato_emi]</p>\n<p style="line-height: 140%;"><strong>Modalidade: </strong>[contrato_mod]</p>\n<p style="line-height: 140%;"> </p>',
                },
              },
            ],
            values: {
              backgroundColor: "",
              padding: "0px",
              border: {
                borderTopWidth: "0px",
                borderTopStyle: "solid",
                borderTopColor: "#000000",
                borderLeftWidth: "0px",
                borderLeftStyle: "solid",
                borderLeftColor: "#000000",
                borderRightWidth: "0px",
                borderRightStyle: "solid",
                borderRightColor: "#000000",
                borderBottomWidth: "0px",
                borderBottomStyle: "solid",
                borderBottomColor: "#000000",
              },
              borderRadius: "0px",
              _meta: { htmlID: "u_column_8", htmlClassNames: "u_column" },
            },
          },
          {
            id: "uC3YgFLQvM",
            contents: [
              {
                id: "jenGIFsLnU",
                type: "text",
                values: {
                  containerPadding: "10px",
                  anchor: "",
                  fontSize: "14px",
                  textAlign: "right",
                  lineHeight: "140%",
                  linkStyle: {
                    inherit: true,
                    linkColor: "#0000ee",
                    linkHoverColor: "#0000ee",
                    linkUnderline: true,
                    linkHoverUnderline: true,
                  },
                  hideDesktop: false,
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_text_13",
                    htmlClassNames: "u_content_text",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                  text: '<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;"><strong>Primeiro Vencimento: </strong>[contrato_p_vencimento]</p>\n<p style="line-height: 140%;"><strong>Dia Vencimento: </strong>[contrato_vencimento]</p>\n<p style="line-height: 140%;"><strong>Vigência: </strong>[contrato_vigencia]</p>\n<p style="line-height: 140%;"><strong>Índice Reajuste: </strong>[contrato_t_reaj]</p>',
                },
              },
            ],
            values: {
              backgroundColor: "",
              padding: "0px",
              border: {},
              borderRadius: "0px",
              _meta: { htmlID: "u_column_16", htmlClassNames: "u_column" },
            },
          },
        ],
        values: {
          displayCondition: null,
          columns: false,
          backgroundColor: "",
          columnsBackgroundColor: "",
          backgroundImage: {
            url: "",
            fullWidth: true,
            repeat: "no-repeat",
            size: "custom",
            position: "center",
          },
          padding: "0px",
          anchor: "",
          hideDesktop: false,
          _meta: { htmlID: "u_row_6", htmlClassNames: "u_row" },
          selectable: true,
          draggable: true,
          duplicatable: true,
          deletable: true,
          hideable: true,
        },
      },
      {
        id: "qQFNaS76dp",
        cells: [1],
        columns: [
          {
            id: "HNljCGEnyl",
            contents: [
              {
                id: "ItdqpJhRon",
                type: "text",
                values: {
                  containerPadding: "10px",
                  anchor: "",
                  fontSize: "18px",
                  textAlign: "center",
                  lineHeight: "110%",
                  linkStyle: {
                    inherit: true,
                    linkColor: "#0000ee",
                    linkHoverColor: "#0000ee",
                    linkUnderline: true,
                    linkHoverUnderline: true,
                  },
                  hideDesktop: false,
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_text_14",
                    htmlClassNames: "u_content_text",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                  text: '<p style="line-height: 110%;"><strong>Total Contrato [contrato_period] - [contrato_vl_tot_cont]</strong></p>',
                },
              },
            ],
            values: {
              backgroundColor: "",
              padding: "0px",
              border: {},
              borderRadius: "0px",
              _meta: { htmlID: "u_column_17", htmlClassNames: "u_column" },
            },
          },
        ],
        values: {
          displayCondition: null,
          columns: false,
          backgroundColor: "",
          columnsBackgroundColor: "",
          backgroundImage: {
            url: "",
            fullWidth: true,
            repeat: "no-repeat",
            size: "custom",
            position: "center",
          },
          padding: "0px",
          anchor: "",
          hideDesktop: false,
          _meta: { htmlID: "u_row_12", htmlClassNames: "u_row" },
          selectable: true,
          draggable: true,
          duplicatable: true,
          deletable: true,
          hideable: true,
        },
      },
      {
        id: "ZQiHIJ3qkP",
        cells: [1],
        columns: [
          {
            id: "ynfD3Yuano",
            contents: [
              {
                id: "touHHjrXva",
                type: "divider",
                values: {
                  width: "100%",
                  border: {
                    borderTopWidth: "1px",
                    borderTopStyle: "solid",
                    borderTopColor: "#BBBBBB",
                  },
                  textAlign: "center",
                  containerPadding: "10px",
                  anchor: "",
                  hideDesktop: false,
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_divider_9",
                    htmlClassNames: "u_content_divider",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                },
              },
              {
                id: "rErsp8b8wH",
                type: "text",
                values: {
                  containerPadding: "10px",
                  anchor: "",
                  fontSize: "14px",
                  textAlign: "left",
                  lineHeight: "140%",
                  linkStyle: {
                    inherit: true,
                    linkColor: "#0000ee",
                    linkHoverColor: "#0000ee",
                    linkUnderline: true,
                    linkHoverUnderline: true,
                  },
                  hideDesktop: false,
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_text_7",
                    htmlClassNames: "u_content_text",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                  text: '<p style="line-height: 140%;"><strong>CLÁUSULA 1 </strong>- O objeto do presente consiste na prestação pela CONTRATADA à CONTRATANTE, dos serviços profissionais de contabilidade abaixo descritos:</p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;"><strong>1.1 - ÁREA CONTÁBIL</strong></p>\n<p style="line-height: 140%;">1.1.1 - Classificação da contabilidade de acordo com normas e princípios contábeis vigentes;</p>\n<p style="line-height: 140%;">1.1.2 - Apuração de balancetes;</p>\n<p style="line-height: 140%;">1.1.3 - Elaboração do balanço anual de demonstrativo de resultados</p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;"><strong>1.2 - ÁREA FISCAL</strong></p>\n<p style="line-height: 140%;">1.2.1 - Orientação e controle de aplicação dos dispositivos legais vigentes, sejam Federais, Estaduais ou Municipais;</p>\n<p style="line-height: 140%;">1.2.2 - Escrituração dos registros fiscais do IPI e/ou ICMS e/ou ISS, e elaboração das guias de informação e dos tributos devidos;</p>\n<p style="line-height: 140%;">1.2.3 - Atendimento das demais exigências previstas na Legislação, bem como, de eventuais procedimentos fiscais;</p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;"><strong>1.3 - ÁREA TRABALHISTA E PREVIDENCIÁRIA</strong></p>\n<p style="line-height: 140%;">1.3.1 - Orientação e controle da aplicação dos preceitos da Consolidação das Leis do Trabalho, bem como aqueles relativas à Previdência Social, PIS, FGTS, Sindicatos e outros aplicáveis às relações de emprego mantidas pela CONTRATANTE.</p>\n<p style="line-height: 140%;">1.3.2 - Manutenção dos Registros de Empregados;</p>\n<p style="line-height: 140%;">1.3.3 - Elaboração da Folha de Pagamento dos empregados e de Pró-Labore, bem como das guias dos encargos sociais e tributos afins a serem recolhidos pela empresa;</p>\n<p style="line-height: 140%;">1.3.4 - Atendimento das demais exigências previstas na legislação, bem como de eventuais procedimentos de fiscalização.</p>\n<p style="line-height: 140%;">1.3.5 - Elaboração anual da RAIS e Declaração de Rendimentos.</p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;"><strong>1.4 - ÁREA DO IMPOSTO DE RENDA PESSOA JURÍDICA: </strong></p>\n<p style="line-height: 140%;">1.4.1. - Orientação e controle de aplicação dos dispositivos legais vigentes;</p>\n<p style="line-height: 140%;">1.4.2. - Elaboração da declaração de rendimentos - IRPJ e documentos correlatos;</p>\n<p style="line-height: 140%;">1.4.3. - Atendimento das demais exigências previstas em atos normativos, bem como de eventuais procedimentos de fiscalização tributária.</p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;"><strong>CLÁUSULA 2 - </strong>A CONTRATANTE<strong> </strong>se compromete preparar mensalmente toda documentação fiscal/ contábil, que deverá ser entregue a este Escritório impreterivelmente, nos dias 01,15 e 25 ou primeiro dia útil subsequentes a estas datas de cada mês, quando não houver expediente no Escritório ou na Empresa em um desses dias, a fim de que a CONTRATADA possa executar seus serviços na conformidade com o citado neste instrumento.</p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;"><strong>CLÁUSULA 3 - </strong>A CONTRATADA assume inteira responsabilidade pelos serviços técnicos realizados, assim, pelas orientações que prestar.</p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;"><strong>CLÁUSULA 4 - </strong>As orientações dadas pela CONTRATADA deverão ser rigorosamente seguidas pela CONTRATANTE, eximindo-se a primeira das consequências da não observância do seu cumprimento.</p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;"><strong>CLÁUSULA 5 - </strong>As multas decorrentes da entrega fora do prazo legal, para pagamento, ou que forem decorrentes da não execução dos serviços por parte da CONTRATADA, serão de responsabilidade da mesma.</p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;"><strong>CLÁUSULA 6 - </strong>A CONTRATANTE pagará à CONTRATADA pelos serviços prestados, os honorários mensais, com vencimento e reajuste conforme informado no início deste contrato.</p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;"><strong>PARÁGRAFO 1 -</strong> Os valores gastos com materiais na execução de serviços, tais como, Livros, Carimbos, Pastas de Arquivos, Disquetes etc. correrão por conta da CONTRATANTE. No caso de o pagamento ser efetuado pela CONTRATADA, este será reembolsado pela primeira, mediante apresentação dos comprovantes.</p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;"><strong>PARÁGRAFO 2 - </strong>Os honorários serão reajustados conforme ÍNDICE DE REAJUSTE anual informados no início deste documento.</p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;"><strong>CLÁUSULA 7 - </strong>No mês de dezembro de cada ano, será cobrado o equivalente a 01(hum) honorário mensal, a ser pago até o dia do vencimento da mensalidade mensal, por conta do Encerramento do Balanço Patrimonial, preenchimento da Rais, elaboração das 1ª e 2ª parcelas do 13º salário, Declaração de Imposto de Renda Pessoa Jurídica, Inventário de Estoque.</p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;"><strong>CLÁUSULA 8 - </strong>Os honorários não pagos na data estipulada serão acrescidos de multa contratual de 2% e juros mensais calculados sobre os honorários vencidos, sem prejuízo da correção monetária incidente no período.</p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;"><strong>CLÁUSULA 9 - </strong>Persistindo o atraso, por período de 03(três) meses, a CONTRATADA, poderá suspender os serviços até sua regularização, eximindo-se de qualquer responsabilidade pelos danos causados, no período da paralização. </p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;"><strong>CLÁUSULA 10 - </strong>DAS DESPESAS EXTRAS – A CONTRATANTE, reembolsará à CONTRATADA o custo de todos os materiais utilizados na execução dos serviços ora ajustados, tais como: livros fiscais, pastas, fotocópias, autenticações, reconhecimento de firmas, custas, emolumentos e taxas exigidas pelos serviços públicos, comunicações telefônicas, carimbos etc., sempre que utilizados e mediante recibo discriminado acompanhado dos respectivos comprovantes de desembolso.</p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;"><strong>CLÁUSULA 11 - </strong>DOS SERVIÇOS EXTRAS - Os serviços solicitados pela CONTRATANTE não especificados na cláusula 1ª serão cobrados pela CONTRATADA em separado, como extraordinários, segundo valor específico constante de orçamento previamente aprovado pela CONTRATANTE.</p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;"><strong>PARÁGRAFO ÚNICO - </strong>Entende-se por serviços extras, todo aquele não relacionado no Anexo 1 deste contrato, tais como: alteração contratual; abertura e baixa de empresa; certidões negativas do INSS, FGTS, Federal, Estadual e Municipal; certidão falência ou protestos; parcelamento de débitos; elaboração de processos de restituição;  cálculos de tributos em atraso; homologações; autenticação/Registro/Encadernação de livros; declaração imposto de renda dos sócios e empregados; serviços de consultoria e assessoria; preenchimento de cadastros e propostas de financiamentos; cadastros do IBGE; contratos de locação, compra, venda e mútuo; SICAF; DIMED, DIMOB, emissão de DECORE; cadastro e atualização do e-social; compra e renovação do certificado digital e outros serviços que não sejam objeto de cláusula contratual.</p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;"><strong>CLÁUSULA 12 - </strong>DA VIGÊNCIA - Este instrumento é feito por tempo indeterminado, iniciando-se conforme data do contrato informado no início do documento, podendo ser rescindido em qualquer época, por qualquer uma das partes, mediante Aviso Prévio de 30 (trinta) dias, por escrito e apresentada as razões da rescisão, período no qual, todas as cláusulas desse contrato permanecem em vigor. </p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;"><strong>PARÁGRAFO ÚNICO - </strong>Em todas as transferências de serviços à outra empresa contábil, a CONTRATANTE deverá informar a CONTRATADA por escrito, o nome, endereço, responsável técnico e número do CRC..........., sem o que não será possível à CONTRATADA cumprir as formalidades ético profissionais, inclusive a transmissão de dados e informações necessárias à continuidade dos serviços, em relação às quais, diante da eventual inércia da CONTRATANTE, estará desobrigada de cumprimento.</p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;"><strong>CLÁUSULA 13 - </strong>Os sócios da CONTRATANTE, para os fins do presente contrato são considerados fiadores solidários e principais pagadores em relação a todas as obrigações contratuais decorrentes.</p>\n<p style="line-height: 140%;"> </p>',
                },
              },
            ],
            values: {
              backgroundColor: "",
              padding: "0px",
              border: {},
              borderRadius: "0px",
              _meta: { htmlID: "u_column_9", htmlClassNames: "u_column" },
            },
          },
        ],
        values: {
          displayCondition: null,
          columns: false,
          backgroundColor: "",
          columnsBackgroundColor: "",
          backgroundImage: {
            url: "",
            fullWidth: true,
            repeat: "no-repeat",
            size: "custom",
            position: "center",
          },
          padding: "0px",
          anchor: "",
          hideDesktop: false,
          _meta: { htmlID: "u_row_7", htmlClassNames: "u_row" },
          selectable: true,
          draggable: true,
          duplicatable: true,
          deletable: true,
          hideable: true,
        },
      },
    ],
    values: {
      popupPosition: "center",
      popupWidth: "600px",
      popupHeight: "auto",
      borderRadius: "10px",
      contentAlign: "center",
      contentVerticalAlign: "center",
      contentWidth: 695,
      fontFamily: { label: "Arial", value: "arial,helvetica,sans-serif" },
      textColor: "#000000",
      popupBackgroundColor: "#FFFFFF",
      popupBackgroundImage: {
        url: "",
        fullWidth: true,
        repeat: "no-repeat",
        size: "cover",
        position: "center",
      },
      popupOverlay_backgroundColor: "rgba(0, 0, 0, 0.1)",
      popupCloseButton_position: "top-right",
      popupCloseButton_backgroundColor: "#DDDDDD",
      popupCloseButton_iconColor: "#000000",
      popupCloseButton_borderRadius: "0px",
      popupCloseButton_margin: "0px",
      popupCloseButton_action: {
        name: "close_popup",
        attrs: {
          onClick:
            "document.querySelector('.u-popup-container').style.display = 'none';",
        },
      },
      backgroundColor: "#ffffff",
      backgroundImage: {
        url: "",
        fullWidth: true,
        repeat: "no-repeat",
        size: "custom",
        position: "center",
      },
      preheaderText: "",
      linkStyle: {
        body: true,
        linkColor: "#0000ee",
        linkHoverColor: "#0000ee",
        linkUnderline: true,
        linkHoverUnderline: true,
      },
      _meta: { htmlID: "u_body", htmlClassNames: "u_body" },
    },
  },
  schemaVersion: 14,
};

export const LayoutOrderContract = {
  counters: {
    u_column: 58,
    u_row: 18,
    u_content_text: 54,
    u_content_divider: 28,
    u_content_menu: 1,
    u_content_heading: 2,
    u_content_image: 1,
  },
  body: {
    id: "0splc-qQYl",
    rows: [
      {
        id: "qXJsTsGzKr",
        cells: [32.11, 67.89],
        columns: [
          {
            id: "bl9U5ULVzJ",
            contents: [
              {
                id: "DWCraE4GF2",
                type: "image",
                values: {
                  containerPadding: "10px",
                  anchor: "",
                  src: {
                    url: sessionStorage.getItem("key_logo")
                      ? `https://qerp-public.s3.sa-east-1.amazonaws.com/${sessionStorage.getItem(
                          "key_logo"
                        )}`
                      : "https://assets.unlayer.com/stock-templates1684262438985-logo.png",
                    width: 130,
                    height: 95,
                  },
                  textAlign: "center",
                  altText: "",
                  action: {
                    name: "web",
                    values: { href: "", target: "_blank" },
                  },
                  hideDesktop: false,
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_image_1",
                    htmlClassNames: "u_content_image",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                },
              },
            ],
            values: {
              backgroundColor: "",
              padding: "0px",
              border: {},
              borderRadius: "0px",
              _meta: { htmlID: "u_column_41", htmlClassNames: "u_column" },
            },
          },
          {
            id: "48yC0fJRh9",
            contents: [
              {
                id: "D_Bhc9C9uu",
                type: "heading",
                values: {
                  containerPadding: "10px",
                  anchor: "",
                  headingType: "h1",
                  fontSize: "22px",
                  textAlign: "right",
                  lineHeight: "140%",
                  linkStyle: {
                    inherit: true,
                    linkColor: "#0000ee",
                    linkHoverColor: "#0000ee",
                    linkUnderline: true,
                    linkHoverUnderline: true,
                  },
                  hideDesktop: false,
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_heading_2",
                    htmlClassNames: "u_content_heading",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                  text: "<strong>Contrato de Serviços: [contrato_num]</strong>",
                },
              },
              {
                id: "Tj52I04zJX",
                type: "text",
                values: {
                  containerPadding: "10px",
                  anchor: "",
                  fontSize: "14px",
                  textAlign: "right",
                  lineHeight: "140%",
                  linkStyle: {
                    inherit: true,
                    linkColor: "#0000ee",
                    linkHoverColor: "#0000ee",
                    linkUnderline: true,
                    linkHoverUnderline: true,
                  },
                  hideDesktop: false,
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_text_39",
                    htmlClassNames: "u_content_text",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                  text: '<p style="line-height: 140%;">Data: [contrato_emi]</p>',
                },
              },
            ],
            values: {
              backgroundColor: "",
              padding: "0px",
              border: {},
              borderRadius: "0px",
              _meta: { htmlID: "u_column_42", htmlClassNames: "u_column" },
            },
          },
        ],
        values: {
          displayCondition: null,
          columns: false,
          backgroundColor: "",
          columnsBackgroundColor: "",
          backgroundImage: {
            url: "",
            fullWidth: true,
            repeat: "no-repeat",
            size: "custom",
            position: "center",
          },
          padding: "0px",
          anchor: "",
          hideDesktop: false,
          _meta: { htmlID: "u_row_15", htmlClassNames: "u_row" },
          selectable: true,
          draggable: true,
          duplicatable: true,
          deletable: true,
          hideable: true,
        },
      },
      {
        id: "8az-CoPOzY",
        cells: [1],
        columns: [
          {
            id: "uyic4IhxT9",
            contents: [
              {
                id: "YP6E21Gz1J",
                type: "text",
                values: {
                  containerPadding: "10px",
                  anchor: "",
                  fontSize: "14px",
                  textAlign: "left",
                  lineHeight: "140%",
                  linkStyle: {
                    inherit: true,
                    linkColor: "#0000ee",
                    linkHoverColor: "#0000ee",
                    linkUnderline: true,
                    linkHoverUnderline: true,
                  },
                  hideDesktop: false,
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_text_1",
                    htmlClassNames: "u_content_text",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                  text: '<p style="line-height: 140%;"><strong>CONTRATADA</strong></p>\n<p style="line-height: 140%;"><strong>[empresa_razao]</strong></p>\n<p style="line-height: 140%;">CNPJ: [empresa_cnpj]               I.E.: [empresa_incs]</p>\n<p style="line-height: 140%;">[empresa_end] - [empresa_comp] - [empresa_bairro] - [empresa_cep]</p>\n<p style="line-height: 140%;">[empresa_cidade] / [empresa_est]</p>\n<p style="line-height: 140%;">[empresa_tel]</p>\n<p style="line-height: 140%;">[empresa_mail]</p>',
                },
              },
            ],
            values: {
              backgroundColor: "",
              padding: "0px",
              border: {},
              _meta: { htmlID: "u_column_1", htmlClassNames: "u_column" },
            },
          },
        ],
        values: {
          displayCondition: null,
          columns: false,
          backgroundColor: "",
          columnsBackgroundColor: "",
          backgroundImage: {
            url: "",
            fullWidth: true,
            repeat: "no-repeat",
            size: "custom",
            position: "center",
          },
          padding: "0px",
          anchor: "",
          hideDesktop: false,
          _meta: { htmlID: "u_row_1", htmlClassNames: "u_row" },
          selectable: true,
          draggable: true,
          duplicatable: true,
          deletable: true,
          hideable: true,
        },
      },
      {
        id: "rQ6IT0pE7Z",
        cells: [1],
        columns: [
          {
            id: "9_BpipsiRi",
            contents: [
              {
                id: "eWTXGN8KuP",
                type: "divider",
                values: {
                  width: "100%",
                  border: {
                    borderTopWidth: "1px",
                    borderTopStyle: "solid",
                    borderTopColor: "#BBBBBB",
                  },
                  textAlign: "center",
                  containerPadding: "10px",
                  anchor: "",
                  hideDesktop: false,
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_divider_2",
                    htmlClassNames: "u_content_divider",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                },
              },
              {
                id: "X8QI4t2gZ0",
                type: "text",
                values: {
                  containerPadding: "10px",
                  anchor: "",
                  fontSize: "14px",
                  textAlign: "left",
                  lineHeight: "140%",
                  linkStyle: {
                    inherit: true,
                    linkColor: "#0000ee",
                    linkHoverColor: "#0000ee",
                    linkUnderline: true,
                    linkHoverUnderline: true,
                  },
                  hideDesktop: false,
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_text_3",
                    htmlClassNames: "u_content_text",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                  text: '<p style="line-height: 140%;"><strong>CONTRATANTE</strong></p>\n<p style="line-height: 140%;"><strong>[cliente_razao]</strong></p>\n<p style="line-height: 140%;">CNPJ: [cliente_cnpj]               I.E.: [cliente_incs]</p>\n<p style="line-height: 140%;">[cliente_end] - [cliente_comp] - [cliente_bairro] - [cliente_cep]</p>\n<p style="line-height: 140%;">[cliente_cidade] / [cliente_est]</p>\n<p style="line-height: 140%;">[cliente_tel]</p>\n<p style="line-height: 140%;">[cliente_mail]</p>',
                },
              },
              {
                id: "70R88NFcEj",
                type: "divider",
                values: {
                  width: "100%",
                  border: {
                    borderTopWidth: "1px",
                    borderTopStyle: "solid",
                    borderTopColor: "#BBBBBB",
                  },
                  textAlign: "center",
                  containerPadding: "5px",
                  anchor: "",
                  hideDesktop: false,
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_divider_3",
                    htmlClassNames: "u_content_divider",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                },
              },
            ],
            values: {
              backgroundColor: "",
              padding: "0px",
              border: {},
              borderRadius: "0px",
              _meta: { htmlID: "u_column_2", htmlClassNames: "u_column" },
            },
          },
        ],
        values: {
          displayCondition: null,
          columns: false,
          backgroundColor: "",
          columnsBackgroundColor: "",
          backgroundImage: {
            url: "",
            fullWidth: true,
            repeat: "no-repeat",
            size: "custom",
            position: "center",
          },
          padding: "0px",
          anchor: "",
          hideDesktop: false,
          _meta: { htmlID: "u_row_2", htmlClassNames: "u_row" },
          selectable: true,
          draggable: true,
          duplicatable: true,
          deletable: true,
          hideable: true,
        },
      },
      {
        id: "NeNr_xfD0S",
        cells: [50],
        columns: [
          {
            id: "o6gS4LrBbl",
            contents: [
              {
                id: "MQPTOY63w4",
                type: "text",
                values: {
                  containerPadding: "10px",
                  anchor: "",
                  fontSize: "14px",
                  textAlign: "left",
                  lineHeight: "90%",
                  linkStyle: {
                    inherit: true,
                    linkColor: "#0000ee",
                    linkHoverColor: "#0000ee",
                    linkUnderline: true,
                    linkHoverUnderline: true,
                  },
                  hideDesktop: false,
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_text_54",
                    htmlClassNames: "u_content_text",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                  text: '<p style="line-height: 90%;">[contrato_itens]</p>',
                },
              },
            ],
            values: {
              backgroundColor: "",
              padding: "0px",
              border: {},
              borderRadius: "0px",
              _meta: { htmlID: "u_column_58", htmlClassNames: "u_column" },
            },
          },
        ],
        values: {
          displayCondition: null,
          columns: false,
          backgroundColor: "",
          columnsBackgroundColor: "",
          backgroundImage: {
            url: "",
            fullWidth: true,
            repeat: "no-repeat",
            size: "custom",
            position: "center",
          },
          padding: "0px",
          anchor: "",
          hideDesktop: false,
          _meta: { htmlID: "u_row_18", htmlClassNames: "u_row" },
          selectable: true,
          draggable: true,
          duplicatable: true,
          deletable: true,
          hideable: true,
        },
      },
      {
        id: "teU9yX1OJg",
        cells: [1],
        columns: [
          {
            id: "WSL12gTNvw",
            contents: [
              {
                id: "k2yuzLex1v",
                type: "divider",
                values: {
                  width: "100%",
                  border: {
                    borderTopWidth: "1px",
                    borderTopStyle: "solid",
                    borderTopColor: "#BBBBBB",
                  },
                  textAlign: "center",
                  containerPadding: "5px",
                  anchor: "",
                  hideDesktop: false,
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_divider_27",
                    htmlClassNames: "u_content_divider",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                },
              },
            ],
            values: {
              backgroundColor: "",
              padding: "0px",
              border: {},
              borderRadius: "0px",
              _meta: { htmlID: "u_column_28", htmlClassNames: "u_column" },
            },
          },
        ],
        values: {
          displayCondition: null,
          columns: false,
          backgroundColor: "",
          columnsBackgroundColor: "",
          backgroundImage: {
            url: "",
            fullWidth: true,
            repeat: "no-repeat",
            size: "custom",
            position: "center",
          },
          padding: "0px",
          anchor: "",
          hideDesktop: false,
          _meta: { htmlID: "u_row_10", htmlClassNames: "u_row" },
          selectable: true,
          draggable: true,
          duplicatable: true,
          deletable: true,
          hideable: true,
        },
      },
      {
        id: "A9BpDladyY",
        cells: [64.56, 35.44],
        columns: [
          {
            id: "ILpcXSY87_",
            contents: [
              {
                id: "6u-xV7ML5P",
                type: "text",
                values: {
                  containerPadding: "10px",
                  anchor: "",
                  fontSize: "14px",
                  textAlign: "left",
                  lineHeight: "140%",
                  linkStyle: {
                    inherit: true,
                    linkColor: "#0000ee",
                    linkHoverColor: "#0000ee",
                    linkUnderline: true,
                    linkHoverUnderline: true,
                  },
                  hideDesktop: false,
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_text_35",
                    htmlClassNames: "u_content_text",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                  text: '<p style="line-height: 140%;"><strong>Tipo de Pagamento: </strong>[contrato_vl_t_pagto]</p>\n<p style="line-height: 140%;"><strong>Dia Vencimento: </strong>[contrato_vencimento]</p>\n<p style="line-height: 140%;"><strong>Primeiro Vencimento: </strong>[contrato_p_vencimento]</p>\n<p style="line-height: 140%;"><strong>Vigência: </strong>[contrato_vigencia]</p>\n<p style="line-height: 140%;"><strong>Índice Reajuste: </strong>[contrato_t_reaj]</p>\n<p style="line-height: 140%;"><strong>Modalidade:</strong> [contrato_mod]</p>',
                },
              },
            ],
            values: {
              backgroundColor: "",
              padding: "0px",
              border: {},
              borderRadius: "0px",
              _meta: { htmlID: "u_column_34", htmlClassNames: "u_column" },
            },
          },
          {
            id: "oWjzaabOu0",
            contents: [
              {
                id: "KUyI5yqc_d",
                type: "text",
                values: {
                  containerPadding: "10px",
                  anchor: "",
                  fontSize: "15px",
                  textAlign: "center",
                  lineHeight: "140%",
                  linkStyle: {
                    inherit: true,
                    linkColor: "#0000ee",
                    linkHoverColor: "#0000ee",
                    linkUnderline: true,
                    linkHoverUnderline: true,
                  },
                  hideDesktop: false,
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_text_36",
                    htmlClassNames: "u_content_text",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                  text: '<p style="line-height: 140%;"><strong>Total Contrato [contrato_period]</strong></p>\n<p style="line-height: 140%;"><strong>[contrato_vl_tot_cont]</strong></p>\n<p style="line-height: 140%;"> </p>',
                },
              },
            ],
            values: {
              backgroundColor: "",
              padding: "0px",
              border: {},
              borderRadius: "0px",
              _meta: { htmlID: "u_column_38", htmlClassNames: "u_column" },
            },
          },
        ],
        values: {
          displayCondition: null,
          columns: false,
          backgroundColor: "",
          columnsBackgroundColor: "",
          backgroundImage: {
            url: "",
            fullWidth: true,
            repeat: "no-repeat",
            size: "custom",
            position: "center",
          },
          padding: "0px",
          anchor: "",
          hideDesktop: false,
          _meta: { htmlID: "u_row_11", htmlClassNames: "u_row" },
          selectable: true,
          draggable: true,
          duplicatable: true,
          deletable: true,
          hideable: true,
        },
      },
      {
        id: "2u7KLln0tb",
        cells: [1],
        columns: [
          {
            id: "QiCW691Xuh",
            contents: [
              {
                id: "tkt-CVY9HU",
                type: "divider",
                values: {
                  width: "100%",
                  border: {
                    borderTopWidth: "1px",
                    borderTopStyle: "solid",
                    borderTopColor: "#BBBBBB",
                  },
                  textAlign: "center",
                  containerPadding: "10px",
                  anchor: "",
                  hideDesktop: false,
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_divider_28",
                    htmlClassNames: "u_content_divider",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                },
              },
              {
                id: "gV1Ygf5b8T",
                type: "text",
                values: {
                  containerPadding: "10px",
                  anchor: "",
                  fontSize: "14px",
                  textAlign: "left",
                  lineHeight: "140%",
                  linkStyle: {
                    inherit: true,
                    linkColor: "#0000ee",
                    linkHoverColor: "#0000ee",
                    linkUnderline: true,
                    linkHoverUnderline: true,
                  },
                  hideDesktop: false,
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_text_37",
                    htmlClassNames: "u_content_text",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                  text: '<p style="line-height: 140%;"><strong>Observação:</strong></p>\n<p style="line-height: 140%;">[contrato_obs]</p>\n<p style="line-height: 140%;"> </p>',
                },
              },
            ],
            values: {
              backgroundColor: "",
              padding: "0px",
              border: {},
              borderRadius: "0px",
              _meta: { htmlID: "u_column_39", htmlClassNames: "u_column" },
            },
          },
        ],
        values: {
          displayCondition: null,
          columns: false,
          backgroundColor: "",
          columnsBackgroundColor: "",
          backgroundImage: {
            url: "",
            fullWidth: true,
            repeat: "no-repeat",
            size: "custom",
            position: "center",
          },
          padding: "0px",
          anchor: "",
          hideDesktop: false,
          _meta: { htmlID: "u_row_14", htmlClassNames: "u_row" },
          selectable: true,
          draggable: true,
          duplicatable: true,
          deletable: true,
          hideable: true,
        },
      },
    ],
    values: {
      popupPosition: "center",
      popupWidth: "600px",
      popupHeight: "auto",
      borderRadius: "10px",
      contentAlign: "center",
      contentVerticalAlign: "center",
      contentWidth: 695,
      fontFamily: { label: "Arial", value: "arial,helvetica,sans-serif" },
      textColor: "#000000",
      popupBackgroundColor: "#FFFFFF",
      popupBackgroundImage: {
        url: "",
        fullWidth: true,
        repeat: "no-repeat",
        size: "cover",
        position: "center",
      },
      popupOverlay_backgroundColor: "rgba(0, 0, 0, 0.1)",
      popupCloseButton_position: "top-right",
      popupCloseButton_backgroundColor: "#DDDDDD",
      popupCloseButton_iconColor: "#000000",
      popupCloseButton_borderRadius: "0px",
      popupCloseButton_margin: "0px",
      popupCloseButton_action: {
        name: "close_popup",
        attrs: {
          onClick:
            "document.querySelector('.u-popup-container').style.display = 'none';",
        },
      },
      backgroundColor: "#ffffff",
      backgroundImage: {
        url: "",
        fullWidth: true,
        repeat: "no-repeat",
        size: "custom",
        position: "center",
      },
      preheaderText: "",
      linkStyle: {
        body: true,
        linkColor: "#0000ee",
        linkHoverColor: "#0000ee",
        linkUnderline: true,
        linkHoverUnderline: true,
      },
      _meta: { htmlID: "u_body", htmlClassNames: "u_body" },
    },
  },
  schemaVersion: 14,
};

export const LayoutBlankContract = {
  counters: { u_column: 4, u_row: 3, u_content_image: 1, u_content_heading: 1 },
  body: {
    id: "kscZPM7fu2",
    rows: [
      {
        id: "465-DLOhKZ",
        cells: [1, 1],
        columns: [
          {
            id: "zqN6lOV2kC",
            contents: [
              {
                id: "mPFGu7CZku",
                type: "image",
                values: {
                  containerPadding: "10px",
                  anchor: "",
                  src: {
                    url: sessionStorage.getItem("key_logo")
                      ? `https://qerp-public.s3.sa-east-1.amazonaws.com/${sessionStorage.getItem(
                          "key_logo"
                        )}`
                      : "https://assets.unlayer.com/stock-templates1684262438985-logo.png",
                    width: 130,
                    height: 95,
                  },
                  textAlign: "center",
                  altText: "",
                  action: {
                    name: "web",
                    values: { href: "", target: "_blank" },
                  },
                  displayCondition: null,
                  _meta: {
                    htmlID: "u_content_image_1",
                    htmlClassNames: "u_content_image",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                },
              },
            ],
            values: {
              backgroundColor: "",
              padding: "0px",
              border: {},
              borderRadius: "0px",
              _meta: { htmlID: "u_column_3", htmlClassNames: "u_column" },
            },
          },
          {
            id: "ni7TJw41LG",
            contents: [],
            values: {
              backgroundColor: "",
              padding: "0px",
              border: {},
              borderRadius: "0px",
              _meta: { htmlID: "u_column_4", htmlClassNames: "u_column" },
            },
          },
        ],
        values: {
          displayCondition: null,
          columns: false,
          backgroundColor: "",
          columnsBackgroundColor: "",
          backgroundImage: {
            url: "",
            fullWidth: true,
            repeat: "no-repeat",
            size: "custom",
            position: "center",
          },
          padding: "0px",
          anchor: "",
          _meta: { htmlID: "u_row_3", htmlClassNames: "u_row" },
          selectable: true,
          draggable: true,
          duplicatable: true,
          deletable: true,
          hideable: true,
        },
      },
    ],
    values: {
      popupPosition: "center",
      popupWidth: "600px",
      popupHeight: "auto",
      borderRadius: "10px",
      contentAlign: "center",
      contentVerticalAlign: "center",
      contentWidth: 695,
      fontFamily: { label: "Arial", value: "arial,helvetica,sans-serif" },
      textColor: "#000000",
      popupBackgroundColor: "#FFFFFF",
      popupBackgroundImage: {
        url: "",
        fullWidth: true,
        repeat: "no-repeat",
        size: "cover",
        position: "center",
      },
      popupOverlay_backgroundColor: "rgba(0, 0, 0, 0.1)",
      popupCloseButton_position: "top-right",
      popupCloseButton_backgroundColor: "#DDDDDD",
      popupCloseButton_iconColor: "#000000",
      popupCloseButton_borderRadius: "0px",
      popupCloseButton_margin: "0px",
      popupCloseButton_action: {
        name: "close_popup",
        attrs: {
          onClick:
            "document.querySelector('.u-popup-container').style.display = 'none';",
        },
      },
      backgroundColor: "#ffffff",
      backgroundImage: {
        url: "",
        fullWidth: true,
        repeat: "no-repeat",
        size: "custom",
        position: "center",
      },
      preheaderText: "",
      linkStyle: {
        body: true,
        linkColor: "#0000ee",
        linkHoverColor: "#0000ee",
        linkUnderline: true,
        linkHoverUnderline: true,
      },
      _meta: { htmlID: "u_body", htmlClassNames: "u_body" },
    },
  },
  schemaVersion: 14,
};
export const contractLayouts = {
  contract: LayoutContract,
  order: LayoutOrderContract,
  blank: LayoutBlankContract,
};
